import { useEffect, useState } from 'react';
import { setactiveItem } from 'store/cards';
import PlaceholderBlock from 'components/placeholder-blocks/PlaceholderBlock';
import CraftFilters from './CraftFilters';
import Pagination from 'components/Pagination';
import CommonItemInfo from 'components/common-item/CommonItemInfo';
import { useDispatch } from 'react-redux';
import CommonItemExpired from 'components/common-item/CommonItemExpired';
import useActiveItem from 'hooks/useActiveItem';
import CraftSelectTooltip from './CraftSelectTooltip';

const CraftSelect = ({ cards, filters, activeBlock, selectItemHandler, offsetCount, setOffsetCount, paginationData, playSound, firstSelectedCard, isLastCardAdded }) => {

  const {activeItem} = useActiveItem();
  const dispatch = useDispatch();
  const [filteredItems, setFilteredItems] = useState([]);

  const classForUsetiful = !isLastCardAdded ? `cards-list__block--${activeBlock.toLowerCase()}` : '';

  const clickOnceHandler = (item) => {
    dispatch(setactiveItem(item))
    playSound('main');
  }

  const doubleClickHandler = (item) => {
    selectItemHandler(item);
    playSound('craftSelectItem');
  }

  useEffect(() => {
    setFilteredItems(cards);
  }, [cards, activeBlock])

  return (
    <section className="craft-select">
      <h2 className="craft-block__title">
        Select {activeBlock}
        {/* <CraftSelectTooltip /> */}
      </h2>

      {activeBlock === 'Prize' && <h3 className="craft-block__title-visible-help">You can go to the Prizes inventory page to combine prize cards.</h3>}

      <CraftFilters filters={filters} activeBlock={activeBlock} firstSelectedCard={firstSelectedCard} />
      {
        !filteredItems.length ? <PlaceholderBlock />
          :
          <ul className={`cards-list__block cards-list__block--min ${classForUsetiful}`}>
            {
              filteredItems.map((item) => (
                <li
                  className={
                    `cards-list__block-item
                    ${activeItem === item ? 'active' : ''}
                    ${
                      item.type.toLowerCase() === 'event'
                        ? (item.is_valid_event === false ? 'cards-list__block-item--expired' : '')
                        : ''
                    }
                    `
                  }
                  title={item.properties.find((item) => item.title === 'Collection').text}
                  key={item.id}
                  onClick={() => clickOnceHandler(item)}
                  onDoubleClick={() => doubleClickHandler(item)}
                >
                  <CommonItemInfo name={item.name} type={item.type} image={item.image} props={item.properties} />
                  <p className="cards-list__block-item-text">{item.type.toLowerCase() === 'prize' ? '$' + item.name : item.name}</p>
                  {item.type === 'Event' && item.is_valid_event === false && (<CommonItemExpired />)}
                </li>
              ))
            }
          </ul>
      }
      <Pagination offsetCount={offsetCount} setOffsetCount={setOffsetCount} paginationData={paginationData} maxCount={50} />
    </section>
  )
}

export default CraftSelect;
